import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5 5h4v6H5zm10 8h4v6h-4zM5 17h4v2H5zM15 5h4v2h-4z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 13h8V3H3v10zm2-8h4v6H5V5zm8 16h8V11h-8v10zm2-8h4v6h-4v-6zM13 3v6h8V3h-8zm6 4h-4V5h4v2zM3 21h8v-6H3v6zm2-4h4v2H5v-2z"
})), 'DashboardTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DashboardTwoTone.js
// module id = 3047
// module chunks = 2